import SimpleModuleWrap from "../../components/templates/SimpleModuleWrap";

export default SimpleModuleWrap